import React, { forwardRef, useEffect, useRef, useState } from "react";
import BasedModal, {
    IProps as ModalProps,
} from "components/BaseModalComponents/BasedModal";
import { Styles } from "react-modal";
import {
    Container,
    Input,
    ItemBlock,
    Label,
    ModalBody,
    StyledDatepicker as DatePicker,
    TimeBlock,
    StyledTimepicker as TimePicker,
    SaveButton,
    ListOfTickers,
    ListTickerItem,
    ScrollbarWrapper,
    TickerName,
} from "../CombineLogsModal/styles";
import { useDispatch } from "react-redux";
import { sendTickerCommand } from "store/reducers/TabsSlice";
import moment from "moment";
import { useAppSelector } from "hooks/redux";

const style: Styles = {
    overlay: {
        position: "fixed",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
        position: "static",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        width: "330px",
        padding: 0,
        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
        borderRadius: "10px",
    },
};

interface IProps extends ModalProps {
    tickerName?: string | null;
    isSection?: boolean;
    sectionId?: number | string;
    onConfirm?: (scheduledTime: string | null) => void;
}

const RealModeTimerModal = ({
    tickerName,
    isOpen,
    onRequestClose,
    isSection,
    sectionId,
    onConfirm,
}: IProps) => {
    const scheduledTime = useAppSelector((state) => {
        if (isSection) return null;
        return state.tabs.srt_schedule?.find(
            (item: any) => item.ticker_name === tickerName,
        )?.scheduled_for;
    });
    const handleSave = () => {
        const runAt =
            date.date.format("YYYY-MM-DD") +
            "T" +
            date.hours.format("HH:mm") +
            ":00.000Z";

        if (isSection && onConfirm) {
            onConfirm(runAt);
        } else if (tickerName) {
            dispatch(
                sendTickerCommand({
                    ticker_name: tickerName,
                    command: "SRT",
                    additionalData: { run_at: runAt },
                }),
            );
        }

        onRequestClose(undefined);
    };
    const [date, setDate] = useState({
        hours: moment().add(1, "minute"),
        date: moment().add(1, "minute"),
    });
    const [dateStrings, setDateStrings] = useState({
        hours: "init",
        date: "init",
    });
    const dispatch = useDispatch();

    useEffect(() => {
        if (scheduledTime) {
            const m = moment.parseZone(scheduledTime);
            setDate({ hours: m, date: m });
        }
    }, [scheduledTime]);

    useEffect(() => {
        if (isOpen && !scheduledTime) {
            setDate({
                hours: moment().add(1, "minute"),
                date: moment().add(1, "minute"),
            });
        }
    }, [isOpen]);

    return (
        <BasedModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={style}
        >
            <Container>
                <ModalBody onClick={() => {}}>
                    {scheduledTime && (
                        <div style={{ lineHeight: "20px", marginBottom: 12 }}>
                            Запланирован перевод{" "}
                            {isSection ? "секции" : "тикера"} в Real режим
                        </div>
                    )}
                    {!isSection && tickerName && (
                        <ItemBlock>
                            <Label>Имя тикера</Label>
                            <TickerName>
                                {tickerName.slice(0, 23)}
                                {tickerName.length > 23 && "..."}
                            </TickerName>
                        </ItemBlock>
                    )}
                    {isSection && (
                        <ItemBlock>
                            <Label>Секция</Label>
                            <TickerName>#{sectionId}</TickerName>
                        </ItemBlock>
                    )}
                    <ItemBlock>
                        <Label>Дата</Label>

                        <DatePicker
                            value={date.date}
                            onChange={(m, dateString) => {
                                console.log("change");
                                setDate({
                                    hours: date.hours,
                                    date: m,
                                });
                                setDateStrings({
                                    hours: dateStrings.hours,
                                    date: dateString,
                                });
                            }}
                            popupStyle={{
                                zIndex: 101,
                            }}
                            inputReadOnly={false}
                            format="YYYY-MM-DD"
                        />
                    </ItemBlock>
                    <ItemBlock>
                        <Label>Время</Label>
                        <TimePicker
                            disabled={false}
                            value={date.hours}
                            onChange={(m, dateString) => {
                                setDate({
                                    hours: m,
                                    date: date.date,
                                });
                                setDateStrings({
                                    hours: dateString,
                                    date: dateStrings.date,
                                });
                            }}
                            placeholder="00:00"
                            format="HH:mm"
                            inputReadOnly={false}
                        />
                    </ItemBlock>
                    <SaveButton
                        disabled={!dateStrings.hours || !dateStrings.date}
                        onClick={handleSave}
                    >
                        Перевести в Real режим
                    </SaveButton>
                </ModalBody>
            </Container>
        </BasedModal>
    );
};

export { RealModeTimerModal };
